import { locale as ptBr } from './pt-br';
import { locale as en } from './en';
import { locale as es } from './es';

const locales = {
    ...ptBr,
    ...en,
    ...es
};

export default locales;
